import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Popover } from '@mui/material';
import { CalendarMonthOutline, ChevronDown } from 'mdi-material-ui';
import { useState, useEffect } from 'react';
import DatePicker from './DatePicker';
import { differenceInCalendarDays } from 'date-fns';
function DateRangePicker(props) {
    const { duration, setDuration } = props;
    const [selectedOption, setSelectedOption] = useState(differenceInCalendarDays(duration.to, duration.from) > 7
        ? 'Custom Range'
        : 'Last 7 Days');
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    useEffect(() => {
        differenceInCalendarDays(duration.to, duration.from) > 7
            ? setSelectedOption('Custom Range')
            : setSelectedOption('Last 7 Days');
    }, [duration]);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(CalendarMonthOutline, { color: "primary", sx: { fontSize: '26px !important' } }), endIcon: _jsx(ChevronDown, { color: "primary", sx: { rotate: !anchorEl ? '360deg' : '180deg', transition: '0.1s' } }), onClick: handleClick, sx: {
                    color: 'text.light',
                    fontSize: 14,
                    border: '1px solid #DCDFE4',
                    fontWeight: 'fontWeightRegular',
                    height: '34px',
                    borderRadius: '4px',
                    '& .MuiButton-endIcon': {
                        backgroundColor: '#F5F4FC',
                        borderRadius: '50%',
                    },
                    '&:hover': {
                        borderColor: '#564345',
                    },
                } }, { children: selectedOption })), anchorEl && (_jsx(Popover, Object.assign({ open: open, anchorEl: anchorEl, id: id, onClose: () => setAnchorEl(null), elevation: 1 }, { children: _jsx(DatePicker, { setSelectedOption: setSelectedOption, selectedOption: selectedOption, duration: duration, setDuration: setDuration, setSelectedMonth: setSelectedMonth, selectedMonth: selectedMonth, handleClose: () => setAnchorEl(null) }) })))] }));
}
export default DateRangePicker;
